import { render } from "./SpeechBubble.vue?vue&type=template&id=5434e4da"
import script from "./SpeechBubble.vue?vue&type=script&lang=js"
export * from "./SpeechBubble.vue?vue&type=script&lang=js"

import "./SpeechBubble.vue?vue&type=style&index=0&id=5434e4da&lang=css"
script.render = render

export default script